import { render } from "./modal-success-receipt.vue?vue&type=template&id=1e46368f&scoped=true&ts=true"
import script from "./modal-success-receipt.vue?vue&type=script&lang=ts"
export * from "./modal-success-receipt.vue?vue&type=script&lang=ts"

import "./modal-success-receipt.vue?vue&type=style&index=0&id=1e46368f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e46368f"]])

export default __exports__